import { baseApi } from "./baseQuery";

const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({

    createProfileFirstTime: build.mutation({
      query: (body) => ({
        url: "api/v1/create-profile",
        method: "POST",
        body:body
      }),
      invalidatesTags:["createProfile"]
    }),

    getProfiles: build.query({
      query: () => {
        return {
          url: `/api/v1/workspaces`,
          method: "GET",
        }
      },
      providesTags:['createProfile']  
    }),

    switchProfile: build.mutation({
      query: (profile_id) => ({
        url: `/api/v1/switch-profile?workspace_id=${profile_id}`,
        method: "GET",
      }),
    }),

    updateProfile: build.mutation({
      query: (body) => ({
        url: "/api/v1/edit-profile"+`?workspace_id=${body.oldProfile}`, 
        method: "POST",
        body:body
      }),
      invalidatesTags:["createProfile"]
    }),

     getCustomersEmail: build.query({
      query: () => ({
        url: `/api/v1/get-emails-dropdown`,
        method: "GET",
      }),
    }),

     updateWorkspace: build.mutation({
      query: (body) => ({
        url: "/api/v1/update-current-workspace", 
        method: "POST",
        body: body,
        headers: {
          'Content-Type': 'application/json',
        }
      }),
      invalidatesTags:["generalSettings"]
    }),

 
  }),

  // @ts-ignore
  overrideExisting: module.hot?.status() === "apply",
});

export const { 
    useCreateProfileFirstTimeMutation,
    useGetProfilesQuery,
    useSwitchProfileMutation,
    useUpdateProfileMutation,
    useGetCustomersEmailQuery,
    useUpdateWorkspaceMutation
 } = authApi;
